module.exports = __webpack_public_path__ + "static/media/doble-check.862b868f.svg";